import { useEffect, useState } from "react";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSwitcher";

const linkClass = ({ isActive }) =>
  [
    "flex items-center gap-3 px-4 py-3 rounded-xl font-extrabold text-sm transition",
    isActive
      ? "bg-blue-600 text-white shadow-sm"
      : "text-slate-500 hover:bg-slate-100 hover:text-slate-700",
  ].join(" ");

export default function LoadingPage() {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {

        if (prev >= 100){
          clearInterval(timer);
          navigate("/admin2/setqr", { replace: true });
          return 100;
        }

        return prev + 5;
      });
    }, 100);
    return () => clearInterval(timer);
  },[navigate]);

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="flex min-h-screen">
        {/* SIDEBAR NAVIGATION */}
        <aside className="w-[260px] shrink-0 bg-white border-r border-slate-200 px-4 py-5 flex flex-col">
          {/* Admin profile block */}
          <div className="flex items-center gap-3 px-2">
            <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" />
            <div className="min-w-0">
              <div className="font-black text-slate-900 leading-tight">
                {t("admin.layout.admin")}
              </div>
              <div className="text-xs text-slate-400 truncate">
                Admin01@gmail.com
              </div>
            </div>
          </div>

          {/* Navigation skeleton placeholders */}
          <div className="mt-6 py-2 px-2 bg-slate-200 rounded-2xl mr-10"></div>
          <div className="px-2 py-2 bg-slate-200 rounded-2xl mt-5 w-full"></div>

          <nav className="px-2 py-2 bg-sky-200  rounded-xl mt-3 w-full">
            <NavLink to="/admin2" end className={linkClass}>
              <span className="text-lg"></span>
            </NavLink>
          </nav>

          <div className="px-2 py-2 bg-slate-200 rounded-2xl mt-10 w-full"></div>

          <nav className="px-5 py-5 bg-sky-200 rounded-xl mt-3 w-full">
            <NavLink to="/admin2/setqr" className={linkClass}>
              <span className="text-lg"></span>
            </NavLink>

            <NavLink to="/admin2/adddestination" className={linkClass}>
              <span className="text-lg"></span>
            </NavLink>

            <NavLink to="/admin2/additionallocation" className={linkClass}>
              <span className="text-lg"></span>
            </NavLink>
          </nav>

          <div className="px-2 py-2 bg-slate-200 rounded-2xl mt-[40px] w-full"></div>

          <nav className="px-2 py-2 bg-sky-200  rounded-xl mt-3 w-full">
            <NavLink to="/admin2/buildings" className={linkClass}>
              <span className="text-lg"></span>
            </NavLink>
          </nav>

          {/* Sign out placeholder */}
          <button className="mt-auto items-center gap-3 px-5 py-5 rounded-lg  bg-blue-950 ">
            <span className="text-lg"></span>
          </button>
        </aside>

        {/* MAIN CONTENT AREA */}
        <div className="flex-1 min-w-0 flex flex-col">
          {/* TOP HEADER BAR */}
          <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6">
            <div className=" px-2 py-2 bg-slate-200 rounded-2xl w-[250px]"></div>

            <LanguageSwitcher />
          </header>

          <header className="h-14 bg-white border-b border-slate-200 flex items-center justify-between px-6">
            <div className=" px-[18px] py-[18px] bg-sky-200 rounded-lg w-[80px]"></div>

            <button className="flex items-center gap-2 rounded-lg px-[18px] py-[18px] bg-sky-200 mr-[250px]"></button>
          </header>

          {/* Loading content */}
          <div className="flex mt-[100px] justify-center h-screen">
            <div className="w-100">

              {/* Loading detail text */}
              <div>
                <div className="text-center text-black text-m font-bold">
                  {t("admin.loading.loadingMap")}
                </div>
                <div className="mt-3 mb-6 text-center text-slate-500 text-xs">
                  {t("admin.loading.pleaseWait")}
                </div>
              </div>

              {/* Progress percentage label */}
              <div className="flex justify-between mb-2">
                <span className=" text-black font-bold text-xs">
                  {t("admin.loading.resources")}
                </span>
                <span className=" text-blue-500 font-bold text-xs">
                  {progress}%
                </span>
              </div>

              {/* Progress bar */}
              <div className="w-full h-3 bg-gray-200 rounded-full shadow-inner overflow-hidden">
                
                <div className="h-full bg-blue-500 transition-all duration-200" style={{ width: `${progress}%`}}/>
              </div>

              {/* Bottom status text */}
              <div>
                <div className="mt-5 mb-6 text-slate-500 text-xs">
                  {t("admin.loading.startingEditor")}
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
